var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.28571 0C1.91964 0 0 2.01562 0 4.5V19.5C0 21.9844 1.91964 24 4.28571 24H17.1429H18.5714C19.3616 24 20 23.3297 20 22.5C20 21.6703 19.3616 21 18.5714 21V18C19.3616 18 20 17.3297 20 16.5V1.5C20 0.670312 19.3616 0 18.5714 0H17.1429H4.28571ZM4.28571 18H15.7143V21H4.28571C3.49554 21 2.85714 20.3297 2.85714 19.5C2.85714 18.6703 3.49554 18 4.28571 18ZM5.71429 6.75C5.71429 6.3375 6.03571 6 6.42857 6H15C15.3929 6 15.7143 6.3375 15.7143 6.75C15.7143 7.1625 15.3929 7.5 15 7.5H6.42857C6.03571 7.5 5.71429 7.1625 5.71429 6.75ZM6.42857 9H15C15.3929 9 15.7143 9.3375 15.7143 9.75C15.7143 10.1625 15.3929 10.5 15 10.5H6.42857C6.03571 10.5 5.71429 10.1625 5.71429 9.75C5.71429 9.3375 6.03571 9 6.42857 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPg);
export default __webpack_public_path__ + "static/media/Pg.8fa45e2970381dcc6fce313a0e44215d.svg";
export { ForwardRef as ReactComponent };